export const ImportStoriesToBuild = src => {
    switch (src) {
        case './story-01/story-pack-pixi-01.js':
            return import('./story-01/story-pack-pixi-01.js');

        case './story-01/story-pack-01.js':
            return import('./story-01/story-pack-01.js');

        case './story-02/story-pack-02.js':
            return import('./story-02/story-pack-02.js');

        case './story-03/story-pack-03.js':
            return import('./story-03/story-pack-03.js');

        case './story-04/story-pack-04.js':
            return import('./story-04/story-pack-04.js');

        case './story-05/story-pack-05.js':
            return import('./story-05/story-pack-05.js');

        case './story-06/story-pack-06.js':
            return import('./story-06/story-pack-06.js');

        case './story-07/story-pack-07.js':
            return import('./story-07/story-pack-07.js');

        case './story-08/story-pack-08.js':
            return import('./story-08/story-pack-08.js');

        case './story-09/story-pack-09.js':
            return import('./story-09/story-pack-09.js');

        case './story-10/story-pack-10.js':
            return import('./story-10/story-pack-10.js');

        case './story-11/story-pack-11.js':
            return import('./story-11/story-pack-11.js');

        case './story-12/story-pack-12.js':
            return import('./story-12/story-pack-12.js');
    }
};

export const StoriesMap = {
    'event-0': './story-01/story-pack-01.js',
    'event-1': './story-02/story-pack-02.js',
    'event-2': './story-03/story-pack-03.js',
    'event-3': './story-04/story-pack-04.js',
    'event-4': './story-05/story-pack-05.js',
    'event-5': './story-06/story-pack-06.js',
    'event-6': './story-07/story-pack-07.js',
    'event-7': './story-08/story-pack-08.js',
    'event-8': './story-09/story-pack-09.js',
    'event-9': './story-10/story-pack-10.js',
    'event-10': './story-11/story-pack-11.js',
    'event-11': './story-12/story-pack-12.js'
};
